import { defineComponent as _defineComponent } from 'vue'
import { inject, ref } from 'vue'

import { isExpandedSymbol } from '@/components/trip/sidebar/utils'

export interface TripSidebarSectionProps {
  title: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TripSidebarSection',
  props: {
    title: null
  },
  setup(__props: any) {



const isExpanded = inject(isExpandedSymbol, ref())

return { __sfc: true,isExpanded }
}

})